export default __webpack_public_path__ + "static/media/samskipper-b.a92fd11d.png";